<div class="repair-form strategy-form-section display-flex-column padding-bottom">
    <form autocomplete="off">
        <div class="responsive-flex form-row form-row-1">
            <div class="input includes-toggle pad-8 flex-centered-container">
                <mat-form-field class="dense-form-feild" appearance="outline" color="accent">
                    <mat-label>Repair Once/Continuous</mat-label>

                    <mat-select>
                        <mat-option *ngFor="let option of REPAIR_TYPE | keyvalue" [value]="option.key">
                            {{option.value}}
                        </mat-option>
                    </mat-select>

                    <!-- <mat-error *ngIf="exitForm.get('takeProfit').hasError('required')">
                        Profit is required
                    </mat-error> -->
                </mat-form-field>
            </div>

            <div class="input pad-8">
                <mat-form-field class="full-width dense-form-feild" appearance="outline" color="accent">
                    <mat-label>Buy/Sell</mat-label>

                    <mat-select>
                        <mat-option value="Buy">
                            Buy
                        </mat-option>
                        <mat-option value="Sell">
                            Sell
                        </mat-option>
                    </mat-select>

                    <!-- <mat-error *ngIf="exitForm.get('bestBidAsk').hasError('required')">
                        Best Bid/Ask is required
                    </mat-error> -->
                </mat-form-field>
            </div>

            <div class="input pad-8">
                <mat-form-field class="full-width dense-form-feild" appearance="outline" color="accent">
                    <mat-label>Order Lots</mat-label>

                    <div class="ng-spin-box-wrapper">
                        <input matInput ngSpinBox>
                    </div>

                    <!-- <mat-error *ngIf="exitForm.get('modTick').hasError('required')">
                        Mod tick is required
                    </mat-error> -->
                </mat-form-field>
            </div>
        </div>

        <div class="responsive-flex form-row form-row-1">
            <div class="input includes-toggle pad-8 flex-centered-container">
                <mat-form-field class="dense-form-feild" appearance="outline" color="accent">
                    <mat-label>Target Profit</mat-label>

                    <div class="ng-spin-box-wrapper">
                        <input matInput ngSpinBox>
                    </div>

                    <!-- <mat-error *ngIf="exitForm.get('takeProfit').hasError('required')">
                        Profit is required
                    </mat-error> -->
                </mat-form-field>
            </div>

            <div class="slider flex-centered-container pad-8">
                {{ currencySymbol }}
                <mat-slide-toggle class="pad-8-hr"></mat-slide-toggle>
                %
            </div>

            <div class="input pad-8">
                <mat-form-field class="full-width dense-form-feild" appearance="outline" color="accent">
                    <mat-label>Best Bid/Ask</mat-label>

                    <div class="ng-spin-box-wrapper">
                        <input matInput ngSpinBox>
                    </div>

                    <!-- <mat-error *ngIf="exitForm.get('bestBidAsk').hasError('required')">
                        Best Bid/Ask is required
                    </mat-error> -->
                </mat-form-field>
            </div>

            <div class="input pad-8">
                <mat-form-field class="full-width dense-form-feild" appearance="outline" color="accent">
                    <mat-label>Mod Tick</mat-label>

                    <div class="ng-spin-box-wrapper">
                        <input matInput ngSpinBox>
                    </div>

                    <!-- <mat-error *ngIf="exitForm.get('modTick').hasError('required')">
                        Mod tick is required
                    </mat-error> -->
                </mat-form-field>
            </div>

            <div class="input pad-8">
                <mat-form-field class="full-width dense-form-feild" appearance="outline" color="accent">
                    <mat-label>Mod Count</mat-label>

                    <div class="ng-spin-box-wrapper">
                        <input matInput ngSpinBox>
                    </div>

                    <!-- <mat-error *ngIf="exitForm.get('modCount').hasError('required')">
                        Mod count is required
                    </mat-error> -->
                </mat-form-field>
            </div>

            <div class="input pad-8">
                <mat-form-field class="full-width dense-form-feild" appearance="outline" color="accent">
                    <mat-label>Timer</mat-label>

                    <div class="ng-spin-box-wrapper">
                        <input matInput ngSpinBox>
                    </div>

                    <!-- <mat-error *ngIf="exitForm.get('timer').hasError('required')">
                        TImer is required
                    </mat-error> -->
                </mat-form-field>
            </div>

            <div class="input pad-8">
                <mat-form-field class="full-width dense-form-feild" appearance="outline" color="accent">
                    <mat-label>Market Order</mat-label>

                    <mat-select>
                        <mat-option value="value">
                            V
                        </mat-option>
                    </mat-select>

                    <!-- <mat-error *ngIf="exitForm.get('marketOrder').hasError('required')">
                        Market order is required
                    </mat-error> -->
                </mat-form-field>
            </div>
        </div>

        <div class="responsive-flex form-row form-row-2">
            <div class="input includes-toggle pad-8 flex-centered-container">
                <mat-form-field class="dense-form-feild" appearance="outline" color="accent">
                    <mat-label>Stop Loss</mat-label>

                    <div class="ng-spin-box-wrapper">
                        <input matInput ngSpinBox>
                    </div>

                    <!-- <mat-error *ngIf="exitForm.get('stopLoss').hasError('required')">
                        Stop loss is required
                    </mat-error> -->
                </mat-form-field>

            </div>

            <div class="slider flex-centered-container pad-8">
                {{ currencySymbol }}
                <mat-slide-toggle class="pad-8-hr"></mat-slide-toggle>
                %
            </div>

            <div class="input pad-8">
                <mat-form-field class="full-width dense-form-feild" appearance="outline" color="accent">
                    <mat-label>Limit Order</mat-label>

                    <mat-select>
                        <mat-option value="value">
                            V
                        </mat-option>
                    </mat-select>

                    <!-- <mat-error *ngIf="exitForm.get('limitOrder').hasError('required')">
                        Limit order is required
                    </mat-error> -->
                </mat-form-field>
            </div>

            <div class="input pad-8">
                <mat-form-field class="full-width dense-form-feild" appearance="outline" color="accent">
                    <mat-label>Limit Price</mat-label>

                    <div class="ng-spin-box-wrapper">
                        <input matInput ngSpinBox>
                    </div>

                    <!-- <mat-error *ngIf="exitForm.get('limitPrice').hasError('required')">
                        Limit price is required
                    </mat-error> -->
                </mat-form-field>
            </div>

            <div class="input pad-8 flex-centered-container">
                <!-- <mat-form-field class="full-width dense-form-feild" appearance="outline" color="accent"> -->
                <mat-checkbox color="accent">Trailing Stoploss</mat-checkbox>
                <!-- </mat-form-field> -->
            </div>

            <div class="input pad-8">
                <mat-form-field class="full-width dense-form-feild" appearance="outline" color="accent">
                    <mat-label>Trailing Ticks</mat-label>

                    <div class="ng-spin-box-wrapper">
                        <input matInput ngSpinBox>
                    </div>

                    <!-- <mat-error *ngIf="exitForm.get('trailingTicks').hasError('required')">
                        Trailing ticks is required
                    </mat-error> -->
                </mat-form-field>
            </div>
        </div>
    </form>

    <ng-container>
        <div class="responsive-flex pad-8">
            <mat-checkbox color="accent" [(ngModel)]="useAdvanceExit">
                Advance Exit
            </mat-checkbox>
        </div>

        <app-advance-indicator-form #indicatorForm *ngIf="useAdvanceExit"></app-advance-indicator-form>
    </ng-container>
</div>
